(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('permissionsController', permissionsController);

    permissionsController.$inject = ['permissions', 'linkService','userService','$timeout'];

    function permissionsController(permissions, linkService,userService,$timeout){
        var vm = this;
        vm.linkService = linkService;
        vm.permissions = (permissions.data) ? permissions.data : [];

        vm.savePermission = function(isValid,permission){
            if(isValid){
                userService.savePermission(linkService.getLinkId(permission._links.self.href))
                    .then(function () {
                        vm.linkService.reloadRoute(linkService.getCurrentRouteName(), null)
                    })
            }
        }
    }
})();
